import React from "react";
import AppSidebar from "./AppSidebar";
import SiteHeader from "./SiteHeader";
import CommandPalette from "../CommandPalette";
import { NotificationProvider } from "../../contexts/NotificationContext";

/**
 * AppLayout — root shell for all authenticated pages.
 *
 * Structure:
 *   ┌─ SiteHeader (48px topbar) ──────────────────────────────┐
 *   ├─ AppSidebar (240px/56px) ─┬─ Main content (flex-1) ─────┤
 *   │                           │                              │
 *   └───────────────────────────┴──────────────────────────────┘
 *
 * CommandPalette is rendered here (portal-style, always mounted)
 * so Cmd+K works on every page without per-page setup.
 */
const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <NotificationProvider>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          overflow: 'hidden',
          background: 'var(--bg-base)',
          color: 'var(--text-primary)',
          fontFamily: 'var(--font-sans)',
        }}
      >
        <SiteHeader />
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          <AppSidebar />
          <main
            style={{
              flex: 1,
              overflow: 'auto',
              background: 'var(--bg-base)',
              position: 'relative',
            }}
          >
            {children}
          </main>
        </div>
        {/* Global Command Palette — responds to Cmd+K and 'open-command-palette' event */}
        <CommandPalette />
      </div>
    </NotificationProvider>
  );
};

export default AppLayout;
